//
// Generated class OnlineItem
//

/// <reference path="OnlineItem_ManagedObject.ts" />

class OnlineItem extends OnlineItem_ManagedObject
{

}
